/* eslint-disable */
import requestRaw from '@/utils/requestRaw'
import requestDev from "@/utils/requestDev";
import { APICore, APIReportPHP } from '@/utils/servicesApi'
const qs = require("qs");

export function loginAgentStored(data) {
  return requestDev({
    url: APIReportPHP() + '/sign-agent/login/stored',
    method: 'POST',
    data: qs.stringify(data) // untuk array data post
  })
}

// const qs = require('qs')
export function loginMemberValidation(data) {
  return requestRaw({
    url: APICore() + '/member/login/validation',
    method: 'POST',
    data: data // untuk array data post
  })
}
export function loginMemberStored(data) {
  return requestRaw({
    url: APICore() + '/member/login/stored',
    method: 'POST',
    data: data // untuk array data post
  })
}
export function getProfile() {
  return requestRaw({
    url: APICore() + '/member/account/profile',
    method: 'GET',
    // data: data // untuk array data post
  })
}

export function logout() {
  return requestRaw({
    url: APICore() + '/member/account/logout',
    method: 'GET',
    // data: data // untuk array data post
  })
}


// WEBPACK FOOTER //
// ./src/api/login.js